import React, { useEffect, useRef, useState, Fragment } from "react";
import { connect } from "react-redux";

import ErrorModal from "../../../components/ModalTemplates/EmptyModal";
import SidePanel from "../../../components/SidePanel";
import SuccessNotification from "../../../components/SuccessNotification";

import CreateCategoryForm from "../../../components/forms/CreateCategoryForm";

import { makeApiCall } from "../../../shared/makeApiCall";
import SimpleDeleteTemplate from "../../../components/ModalTemplates/SimpleDeleteTemplate";

const Categories = (props) => {
  const { checkRequestError, userId } = props;

  useEffect(() => {
    document.title = "Categories";

    fetchAllCategories();
  }, []);

  const [errorModalOpen, setErrorModalOpen] = useState({
    open: false,
    title: null,
    subtitle: null,
  });
  const [loading, setLoading] = useState(true);
  const [openDeleteModal, setOpenDeleteModel] = useState({
    actionMessage: "",
    actionFunc: null,
    itemId: 0,
    message: "",
    open: false,
    title: "",
  });
  const [openSidePanel, setOpenSidePanel] = useState(false);
  const [categories, setCategories] = useState([]);
  const [show, setShow] = useState({ show: false });
  const [sidePanelExtra, setSidePanelExtra] = useState({
    childComponent: null,
  });

  const searchRef = useRef();

  var pageNumber = 1;
  var searchValue = null;
  var totalPages = 0;

  var isLoading = true;

  const fetchAllCategories = async function () {
    if (pageNumber == 1) {
      setLoading(true);
      if (searchValue != null) {
        setCategories([]);
      }
    }

    isLoading = true;
    const authData = {
      action: "fetchAllCategories",
      userId: userId,
      search: searchValue,
      pageNumber: pageNumber,
    };
    let callResult = await makeApiCall(authData);

    if (callResult.success) {
      if (pageNumber > 1) {
        if (callResult.data.categories.length > 0) {
          setCategories((categories) => [
            ...categories,
            ...callResult.data.categories,
          ]);
        }
      } else {
        totalPages = callResult.data.total;
        setCategories(callResult.data.categories);
      }
      setLoading(false);
      isLoading = false;
    } else {
      const isLogout = checkRequestError(callResult.errorStatus);
      if (!isLogout) {
        setErrorModalOpen({
          open: true,
          title: "Sorry!",
          subtitle: "We could not fetch the data, please refresh the page.",
        });
        isLoading = false;
        setLoading(false);
      }
    }
  };

  const deleteCategoryFunc = async function (categoryId) {
    const authData = {
      action: "deleteCategory",
      userId: userId,
      categoryId: categoryId,
    };
    let callResult = await makeApiCall(authData);

    if (callResult.success) {
      setOpenDeleteModel({ open: false });
      setShow({ show: true, title: "Category deleted." });
      const updatedCategories = categories.filter(
        (category) => category.categoryId !== categoryId
      );
      setCategories(updatedCategories);
    } else {
      const isLogout = checkRequestError(callResult.errorStatus);
      if (!isLogout) {
        setErrorModalOpen({
          open: true,
          title: "Sorry!",
          subtitle: "We could not delete the category, please try again.",
        });
      }
    }
  };

  const handleSearch = () => {
    searchValue = searchRef.current.value;

    pageNumber = 1;
    totalPages = 1;
    if (searchValue.length >= 3) {
      //   fetchAllCategories();
    }
  };

  return (
    <div>
      <main>
        <div className="mx-auto py-6 sm:px-6 lg:px-8">
          {/* Start here */}
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                {/* <h1 className="text-xl font-semibold text-gray-900">
                  Categories
                </h1> */}
                <input
                  type="search"
                  name="searchCategory"
                  id="searchCategory"
                  className="block w-1/3 mt-2 rounded-lg rounded-l-md pl-2 sm:text-md border border-gray-300"
                  placeholder="Search"
                  onChange={handleSearch}
                  ref={searchRef}
                />
              </div>
              <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <button
                  type="button"
                  className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-yellow-400 hover:bg-yellow-500"
                >
                  Filter
                </button>
                <button
                  type="button"
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 sm:w-auto ml-2"
                  onClick={() => {
                    setSidePanelExtra({
                      childComponent: (
                        <CreateCategoryForm
                          categories={categories}
                          category={null}
                          checkRequestError={checkRequestError}
                          fetchAllCategories={fetchAllCategories}
                          isEdit={false}
                          setCategories={setCategories}
                          setErrorModalOpen={setErrorModalOpen}
                          setOpen={setOpenSidePanel}
                          setShow={setShow}
                          setSidePanelExtra={setSidePanelExtra}
                          subtitle="Fill in the information below to add a new category."
                          title="Add new category"
                          userId={userId}
                        />
                      ),
                    });
                    setOpenSidePanel(true);
                  }}
                >
                  Add category
                </button>
              </div>
            </div>
            <div className="-mx-4 mt-8 overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:-mx-6 md:mx-0 md:rounded-lg">
              <table className="min-w-full divide-y divide-gray-300">
                <thead className="bg-gray-50">
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                    >
                      Name
                    </th>
                    <th
                      scope="col"
                      className="relative py-3.5 pl-3 pr-4 sm:pr-6"
                    >
                      <span className="sr-only">Edit</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {categories.map((category) => (
                    <tr key={category.categoryId}>
                      <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
                        <div className="flex items-center space-x-3">
                          <div
                            style={{ backgroundColor: category.categoryColor }}
                            className="w-5 h-5 rounded-full "
                          ></div>
                          <div className="pl-4"> {category.categoryName} </div>
                        </div>
                      </td>
                      <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                        <button
                          className="text-indigo-600 hover:text-indigo-900"
                          onClick={() => {
                            setSidePanelExtra({
                              childComponent: (
                                <CreateCategoryForm
                                  categories={categories}
                                  category={category}
                                  fetchAllCategories={fetchAllCategories}
                                  isEdit={true}
                                  setCategories={setCategories}
                                  setErrorModalOpen={setErrorModalOpen}
                                  setOpen={setOpenSidePanel}
                                  setShow={setShow}
                                  setSidePanelExtra={setSidePanelExtra}
                                  subtitle={null}
                                  title={"Editing " + category.categoryName}
                                  userId={userId}
                                />
                              ),
                            });
                            setOpenSidePanel(true);
                          }}
                        >
                          Edit
                        </button>
                        <button
                          className="text-indigo-600 hover:text-indigo-900 ml-2"
                          onClick={() => {
                            setOpenDeleteModel({
                              actionMessage: "Delete",
                              actionFunc: deleteCategoryFunc,
                              itemId: category.categoryId,
                              message:
                                "Are you sure you want to delete  " +
                                category.categoryName +
                                "?",
                              open: true,
                              title: "Delete " + category.categoryName + "?",
                            });
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <SimpleDeleteTemplate
          open={openDeleteModal.open}
          setOpen={setOpenDeleteModel}
          {...openDeleteModal}
        />
        <ErrorModal
          open={errorModalOpen.open}
          title={errorModalOpen.title}
          setOpen={setErrorModalOpen}
          subtitle={errorModalOpen.subtitle}
        />
        <SidePanel
          open={openSidePanel}
          setOpen={setOpenSidePanel}
          childComponent={sidePanelExtra.childComponent}
          size={sidePanelExtra.size}
        />
        <SuccessNotification
          show={show.show}
          setShow={setShow}
          title={show.title}
        />
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
  };
};

export default connect(mapStateToProps)(Categories);
